
import { Component, computed, inject, Signal } from '@angular/core';
import { AuthService } from '@webapp/auth/services/auth.service';
import {
  ITableColumns,
  TableSkeletonComponent,
} from '@webapp/core/ui/components/table-skeleton/table-skeleton.component';
import { UsersStoreService } from '../../../store/users-store.service';

@Component({
  selector: 'app-users-table-skeleton',
  imports: [TableSkeletonComponent],
  templateUrl: './users-table-skeleton.component.html',
  styleUrl: './users-table-skeleton.component.scss',
})
export class UsersTableSkeletonComponent {
  authService = inject(AuthService);
  usersStore = inject(UsersStoreService);

  prospectColumns: ITableColumns[] = [
    { name: 'Asegurado', component: 'userBadge' },
    { name: 'Documento', component: 'default' },
    { name: 'Productor', component: 'iconTitle' },
  ];

  clientColumns: ITableColumns[] = [
    { name: 'Asegurado', component: 'userBadge' },
    { name: 'Dirección', component: 'default' },
    { name: 'Documento', component: 'default' },
    { name: 'Fecha de nacimiento', component: 'default' },
    { name: 'Productor', component: 'iconTitle' },
    { name: 'Estado', component: 'default' },
  ];

  get columns(): Signal<ITableColumns[]> {
    return computed(() => {
      return this.usersStore.hasProspectFilter()()
        ? this.filterColumns(this.prospectColumns)
        : this.filterColumns(this.clientColumns);
    });
  }

  filterColumns(columns: ITableColumns[]) {
    return columns.filter(
      (column) =>
        this.authService.isUserNotAgent() || column.name !== 'Productor'
    );
  }
}
